<script setup lang="ts">
import Typography from '@components/Typography.vue';
import { OfferService } from '@enums/offerService';
import CheckableTagGroup from '@pages/search/components/filters/CheckableTagGroup.vue';
import { trans } from '@tools/translation.ts';

interface ContractTypeProps {
  selected?: string[];
}

const { selected = [] } = defineProps<ContractTypeProps>();

const emit = defineEmits<{(e: 'update:selected', value: string[]): void}>();

const categories = {
  internet: [
    OfferService.WIFI,
    OfferService.OFFICE_DEDICATED_NETWORK,
    OfferService.FIBER,
    OfferService.ACCESS_SERVER,
    OfferService.RJ45,
  ],
  comfort: [
    'pets_allowed',
    OfferService.ERP,
    OfferService.OFFICE_WAITING_ROOM,
    OfferService.OFFICE_RELAXATION_AREA,
    OfferService.OFFICE_KITCHEN,
    OfferService.OFFICE_HOUSEHOLD,
    OfferService.OFFICE_CAFETERIA,
    OfferService.PMR,
    OfferService.OFFICE_CAFETERIA,
    OfferService.OFFICE_AC,
  ],
  equipments: [
    OfferService.OFFICE_TABLES_CHAIRS,
    OfferService.OFFICE_SCANNER,
    OfferService.OFFICE_PRINTER,
    OfferService.OFFICE_PHOTOCOPIER,
  ],
  services: [
    OfferService.HAS_PHONE_BOX,
    OfferService.HAS_ACTUALLY_MEETING_ROOM,
    OfferService.OFFICE_STORAGE_POINT,
    OfferService.PRIVATE_MEETING_ROOM,
    OfferService.OFFICE_PAYABLE_PARKING,
    OfferService.OFFICE_MAIL,
    OfferService.OFFICE_INDIVIDUAL_STORAGE,
    OfferService.OFFICE_FREE_PARKING,
    OfferService.OFFICE_DOMICILIATION,
    OfferService.OFFICE_BIKE_PARKING,
  ],
  security: [
    OfferService.OFFICE_SEPARATE_ENTRANCE,
    OfferService.OFFICE_LOCKER,
    OfferService.OFFICE_BADGE_ACCESS,
  ],
};
</script>

<template>
  <div>
    <div
      v-for="(services, category) in categories"
      :key="category"
    >
      <Typography
        variant="sub-heading"
        color="gray-darker"
        class="py-3"
      >
        {{ trans(`search.filters.other_filters.services.${category}`) }}
      </Typography>

      <CheckableTagGroup
        :options="services"
        :selected="selected"
        :translation-prefix="`search.filters.other_filters.services`"
        @update:selected="emit('update:selected', $event)"
      />
    </div>
  </div>
</template>
